import React from 'react'
import { Button, Result } from 'antd'
import { useNavigate } from 'react-router-dom';
import config from '../../config';

const NotFound = () => {
    let history = useNavigate();
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                padding: '16px 32px',
                backgroundColor: '#fff',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={<Button type="primary" onClick={() => { history(config.defaultPathHome) }}>Back Home</Button>}
            />
        </div>
    )
}

export default NotFound
